import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'

interface SearchState {
  currentQuery: string
  historyOfQueries: string[]
  isModalOpen: boolean
  hasSearchBar: boolean
}

const initialState: SearchState = {
  currentQuery: '',
  historyOfQueries: [],
  isModalOpen: false,
  hasSearchBar: false,
}

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    addSearchQueryHistory: (state, action: PayloadAction<string>) => {
      const { historyOfQueries } = state
      const isKeyExists = historyOfQueries.includes(action.payload)

      if (isKeyExists) {
        return state
      }

      return {
        ...state,
        historyOfQueries: [action.payload, ...historyOfQueries].slice(0, 10),
      }
    },
    removeFromSearchQueryHistory: (state, action: PayloadAction<string>) => {
      const updatedHistory = state.historyOfQueries.filter((history) => history !== action.payload)

      return {
        ...state,
        historyOfQueries: updatedHistory,
      }
    },
    setCurrentSearchQuery: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        currentQuery: action.payload,
      }
    },
    toggleSearchModal: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isModalOpen: action.payload,
      }
    },
    toggleSearchBar: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        hasSearchBar: action.payload,
      }
    },
  },
})

export const selectHistoryOfQueries = (state: RootState): string[] => state.search.historyOfQueries
export const selectSearchModalVisibility = (state: RootState): boolean => state.search.isModalOpen
export const selectCurrentSearchQuery = (state: RootState): string => state.search.currentQuery
export const selectHasSearchBar = (state: RootState): boolean => state.search.hasSearchBar
export const {
  addSearchQueryHistory,
  removeFromSearchQueryHistory,
  toggleSearchModal,
  setCurrentSearchQuery,
  toggleSearchBar,
} = searchSlice.actions
export default searchSlice.reducer
